var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import TextFirstAlphabetAsIcon from "@frameworks/shared-library/components/TextFirstAlphabetAsIcon/TextFirstAlphabetAsIcon";
import "@frameworks/salesjourney/stylesheets/components/Features/ActivityBook/RM_Orderbook/common/ClientNamesWithClientCodes/ClientNamesWithClientCodes.scss";
import { alphabetsColorsConfigMap } from "@frameworks/shared-library/components/TextFirstAlphabetAsIcon/colorConfigurationsForTextFirstAlphabetAsIcon";
import GenericTooltip from "@frameworks/web/components/generic/GenericTooltip";
var ClientNamesWithClientCodes = function (props) {
    var _a;
    var _b = __read(useState(false), 2), displayTooltip = _b[0], setDisplayTooltip = _b[1];
    var showTooltip = function (e) {
        if (e.currentTarget.offsetWidth >= 160) {
            setDisplayTooltip(true);
        }
    };
    return (React.createElement("div", { className: "primary-client-names-with-client-codes-container d-flex align-items-center gap-10 ".concat((_a = props === null || props === void 0 ? void 0 : props.parentClassName) !== null && _a !== void 0 ? _a : "") },
        React.createElement(TextFirstAlphabetAsIcon, { textToExtractWordFrom: props === null || props === void 0 ? void 0 : props.clientName, textAndBackgroundColorCollection: alphabetsColorsConfigMap }),
        React.createElement("div", { className: "d-flex flex-column" },
            (props === null || props === void 0 ? void 0 : props.wrapClientName) ? (React.createElement(GenericTooltip, { container: document.body, toolTipClassName: "desk-tooltips client-name-with-client-codes-tooltip", placement: "top", triggerType: "hover", externalClassName: "remove-btn-props", toolTipText: props === null || props === void 0 ? void 0 : props.clientName, isExist: true, showTooltip: displayTooltip, noButton: false, button: React.createElement("span", { className: "DMsanL_12_300 txt-han-blue wrapped-client-name d-block", onMouseOver: showTooltip, onMouseOut: function () { return setDisplayTooltip(false); } }, props === null || props === void 0 ? void 0 : props.clientName) })) : (React.createElement("span", { className: "DMsanL_12_300 txt-han-blue" }, props === null || props === void 0 ? void 0 : props.clientName)),
            React.createElement("span", { className: "DMsanR_09_400 txt_medium-gray" }, props === null || props === void 0 ? void 0 :
                props.clientCode,
                " | Client"))));
};
export default ClientNamesWithClientCodes;
